export default __webpack_public_path__ + "static/media/SEA_8394.423450ca.jpg";